// NOTE: NSAI-6677 — mirrors of the server's agent-import limits
// (`apps/nsai/server/src/integration/agent-import/agent-import.constants.ts`).
// The client enforces them up front so an oversized entry is reported on its
// own row instead of failing a whole batch at the server.

// NOTE: Per-request cap on the server's import DTOs (ArrayMaxSize). The client
// splits a larger selection into sequential requests of this size.
export const AGENT_IMPORT_MAX_AGENTS_PER_REQUEST = 25;

export const AGENT_IMPORT_MAX_NAME_LENGTH = 1_000;
export const AGENT_IMPORT_MAX_DESCRIPTION_LENGTH = 10_000;
export const AGENT_IMPORT_MAX_INSTRUCTIONS_LENGTH = 100_000;

// NOTE: Bounds on the file itself, checked before and while parsing. A
// migration file is a list of prompts; anything past these is almost
// certainly the wrong file.
export const AGENT_IMPORT_MAX_FILE_BYTES = 5 * 1024 * 1024;
export const AGENT_IMPORT_MAX_AGENTS_PER_FILE = 500;

export const AGENT_IMPORT_ACCEPTED_EXTENSIONS = [".json", ".csv"] as const;

// NOTE: What the "Download template" link hands the user — the columns the
// parser reads first, with one example row to overwrite.
export const AGENT_IMPORT_CSV_TEMPLATE = [
  "name,description,instructions",
  '"Sales assistant","Qualifies inbound leads","You are a friendly sales assistant. Ask about the company size and budget, then suggest a demo."',
  "",
].join("\n");
